// 页面名称枚举，用于标识页面组件
export const PAGE_NAME = {
  home: 'home', // 首页
  social: 'social', // 社招
  campus: 'campus', // 校招
  positionList: 'positionList', // 职位列表
  positionDetail: 'positionDetail', // 职位详情
  deliverySuccess: 'deliverySuccess', // 投递成功
  deliveryConfirm: 'deliveryConfirm', // 投递确认
  personalCenter: 'personalCenter', // 个人中心
  login: 'login', // 登录页
  campusTV: 'campusTV', // 校招TV
  question: 'question', // 常见问题
  about: 'about', // 了解美团
  beiDou: 'beiDou', // 北斗计划
  qiHang: 'qiHang', // 起航计划
  sharePosition: 'sharePosition', // 分享职位落地页
  campusSchedule: 'campusSchedule', // 校招行程
  resumeDetail: 'resumeDetail', // 简历详情
  deliveryRecord: 'deliveryRecord', // 投递记录
  accountSetting: 'accountSetting', // 账号设置
  beidouProgram: 'beidouProgram', // 北斗新页面
};

// 微信扫码样式文件
export const qrCodeUrl =
  '//s3plus.meituan.net/v1/mss_2b9f8260d56a4db7a43f86aebe87a9a4/zhaopin-static-source/qrcode.css';

// 页面灵犀埋点cid
export const PAGE_CID = {
  [PAGE_NAME.login]: 'c_ead_qr0i2xtl',
  [PAGE_NAME.home]: 'c_ead_9x0bl03e',
  [PAGE_NAME.positionDetail]: 'c_ead_uaxi3y2c',
  // [PAGE_NAME.deliveryConfirm]: 'c_ead_g8b3ie54',
  // [PAGE_NAME.deliverySuccess]: 'b_ead_3jmrca9n_mc',
  [PAGE_NAME.about]: 'c_ead_ichtcdd9',
  [PAGE_NAME.question]: 'c_ead_zfpzejsf',
  [PAGE_NAME.social]: 'c_ead_96u0b4mt',
  [PAGE_NAME.campus]: 'c_ead_uxks530l',
  [PAGE_NAME.beiDou]: 'c_ead_oytx6tjk',
  [PAGE_NAME.qiHang]: 'c_ead_gvqclp8c',
  [PAGE_NAME.campusTV]: 'c_ead_z5zcpuhw',
  [PAGE_NAME.positionList]: 'c_ead_5xl7xizw',
  [PAGE_NAME.beidouProgram]: 'c_ead_auyaa5ad',
};

// 页面title 名称cid
export const PAGE_TITLE = {
  [PAGE_NAME.home]: '首页 | 美团招聘',
  [PAGE_NAME.social]: '社会招聘 | 美团招聘',
  [PAGE_NAME.campus]: '校园招聘 | 美团招聘',
  [PAGE_NAME.positionList]: '职位列表 | 美团招聘',
  [PAGE_NAME.positionDetail]: '职位详情 | 美团招聘',
  [PAGE_NAME.login]: '登录 | 美团招聘',
  [PAGE_NAME.about]: '了解美团 | 美团招聘',
  [PAGE_NAME.question]: '常见问题 | 美团招聘',
  [PAGE_NAME.personalCenter]: '个人中心 | 美团招聘',
  [PAGE_NAME.beiDou]: '北斗计划 | 美团招聘',
  [PAGE_NAME.qiHang]: '零售启航计划 | 美团招聘',
  [PAGE_NAME.campusTV]: '校招TV | 美团招聘',
  [PAGE_NAME.campusSchedule]: '校招行程 | 美团招聘',
  [PAGE_NAME.resumeDetail]: '个人中心 | 美团招聘',
  [PAGE_NAME.deliveryRecord]: '个人中心 | 美团招聘',
  [PAGE_NAME.accountSetting]: '个人中心 | 美团招聘',
  [PAGE_NAME.beidouProgram]: '北斗计划 | 美团招聘',
};

// 职位搜索放到url上的参数 -------start-------
export const CITY_LIST = 'cityList';
export const SEARCH_CITY = 'searchCity';
export const BG = 'bg';
export const HIRING_TYPE = 'hiringType';
export const JF_JG_LIST = 'jfJgList';
export const PAGE_NO = 'pageNo';
export const TOKEN = 'token';
// 职位搜索放到url上的参数 -------end-------

export const SOURCE_TYPE = {
  campus: '12',
  campusWeChat: '14',
  campusBole: '15',
  campusWeChatBole: '16',
  campusWeChatBoleQRCode: '25',
  social: '11',
  socialWeChat: '13',
  socialBole: '17',
  socialWeChatBole: '18',
  socialWeChatBoleQRCode: '23',
};

export const LX_RESUME_EDIT_MODULE_VIEW = {
  uploadResume: 'b_ead_61dp17ra_mv',
  eduExperience: 'b_ead_8wicxw3n_mv',
  workExperience: 'b_ead_lchydh6j_mv',
  projectExperience: 'b_ead_ronixv2z_mv',
  campusExperience: 'b_ead_ixfor9bz_mv',
  honor: 'b_ead_9fcktr3l_mv',
  languageStandard: 'b_ead_afnl08d9_mv',
  certificate: 'b_ead_zzspa69i_mv',
  skillStandard: 'b_ead_44j8ich9_mv',
  paper: 'b_ead_io6aeydi_mv',
  competition: 'b_ead_ej7x80zh_mv',
  sampleReels: 'b_ead_c6neqa54_mv',
  patent: 'b_ead_m7qz0rxx_mv',
  exam: 'b_ead_hjdeia64_mv',
  socialAccount: 'b_ead_pm6xth8x_mv',
  selfDescription: 'b_ead_tr3pdc6p_mv',
};

export const LX_RESUME_EDIT_MODULE_ADD = {
  uploadResume: 'b_ead_wqug1si0_mc',
  resumeEduExpList: 'b_ead_mxfshgbu_mc',
  resumeWorkExpList: 'b_ead_fc9u9rgc_mc',
  resumeProjectExpList: 'b_ead_ronixv2z_mv',
  resumeCampusExpList: 'b_ead_fuq2d7x3_mc',
  resumeHonorList: 'b_ead_b3yqep4r_mc',
  resumeLanguageList: 'b_ead_26za921a_mc',
  resumeCertificateList: 'b_ead_m4vz8fg1_mc',
  resumeSkillList: 'b_ead_gfcoe0hd_mc',
  resumeThesisList: 'b_ead_zaswj39y_mc',
  resumeCompetitionList: 'b_ead_sntv2nv0_mc',
  resumeWorksAttachmentList: 'b_ead_scr1x9uf_mc',
  resumePatentList: 'b_ead_7abfxxrj_mc',
  resumeExamList: 'b_ead_gxkcgnd1_mc',
  resumeSocialAccountList: 'b_ead_klhqf5oj_mc',
  // TODO： 需要确认是不是要添加自我描述
};

export const LX_RESUME_EDIT_MODULE_DELETE = {
  uploadResume: '',
  resumeEduExpList: 'b_ead_g5znsbcy_mc',
  resumeWorkExpList: 'b_ead_q8bb5d59_mc',
  resumeProjectExpList: 'b_ead_8qo1y0ol_mc',
  resumeCampusExpList: 'b_ead_nqixbrtp_mc',
  resumeHonorList: 'b_ead_avhtixmy_mc',
  resumeLanguageList: 'b_ead_g8ccjqj8_mc',
  resumeCertificateList: 'b_ead_lkemex20_mc',
  resumeSkillList: 'b_ead_lh0aov9j_mc',
  resumeThesisList: 'b_ead_466antfi_mc',
  resumeCompetitionList: 'b_ead_nx8u74wn_mc',
  resumePatentList: 'b_ead_aob9f2bp_mc',
  resumeExamList: 'b_ead_r7aj8i7s_mc',
  resumeSocialAccountList: 'b_ead_k4vj45gj_mc',
  // TODO： 需要确认是不是要添加自我描述
};

export const LX_RESUME_EDIT = {
  resumeEditView: 'c_ead_ib2loap8',
  resumeEditSave: 'b_ead_xzas0lks_mc',
  switchToSocial: 'b_ead_honmtvca_mc',
  switchToCampus: 'b_ead_k93syy6f_mc',
};

export const LX_RESUME = {
  emptyView: 'b_ead_au8zaznb_mv',
  resumeCreate: 'b_ead_al8n3dmm_mc',
  typeSelectView: 'b_ead_i1qne6ot_mv',
  selectCampus: 'b_ead_ns92n8mu_mc',
  selectSocial: 'b_ead_yq06kx6v_mc',
  resumeView: 'c_ead_hd3dt8f2',
  resumeEdit: 'b_ead_k1vqo2jx_mc',
};

export const LX_ABOUT_VIEW = {
  vocationAndDuty: 'b_ead_3jl5fjky_mv',
  ourTeam: 'b_ead_0p7a493o_mv',
  workInMeituan: 'b_ead_kcoymkn1_mv',
};

export const LX_PERSONAL_CENTER_VIEW = {
  accountSetting: 'c_ead_67l1lqcg',
  deliveryRecord: 'c_ead_r2w61jkx',
};

export const LX_SEARCH_CLICK = {
  home: 'b_ead_ea55efnd_mc',
  social: 'b_ead_akmkg9is_mc',
  campus: 'b_ead_00h4y8si_mc',
  about: 'b_ead_j6mwyp8h_mc',
  position: 'b_ead_0bqawmwo_mc',
  beidou: 'b_ead_mg484fkh_mc',
  qihang: 'b_ead_jzr60obu_mc',
};

export const num2Chinese = {
  0: '零',
  1: '一',
  2: '二',
  3: '三',
  4: '四',
  5: '五',
  6: '六',
  7: '七',
  8: '八',
  9: '九',
};

export const INTENTION_JOB = 'intentionJob';
export const INTENTION_BG = 'interestBG';
export const WORK_CITY_LIST = 'workCityList';
export const WORK_DIRECTION = 'aspirationDirectionCodeList';
export const DEPARTMENT_CUSTOM_ID = 'customId000';
export const DIRECTION_CUSTOM_ID = '-1';

/**
 * @description: 职位申请错误码
 */
export const applyErrorCode = {
  /**
   * @description: 有意向职位毕业时间不满足
   */
  code10001: '10001',
  /**
   * @description: 无意向职位毕业时间不满足
   */
  code10002: '10002',
};

export const RESUME_EDITOR_CALLER = {
  resumeDetail: 'resumeDetail',
  deliveryConfirm: 'deliveryConfirm',
};

export const LX_SEARCH_OVERSEAS_CITY_PATH = {
  '/social': 'b_ead_zobsiow3_mc',
  '/campus': 'b_ead_h58u7ybc_mc',
};
